import api from "./Api";

class PdvFinalizadoraService {
  GetConfiguracao() {
    return api.get("/v1/PdvFinalizadora/Configuracao").then((response) => {
      return response.data;
    });
  }

  PostFinalizadora(payload) {
    return api
      .post("/v1/PdvFinalizadora/Finalizadora", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutFinalizadora(payload) {
    return api
      .put("/v1/PdvFinalizadora/Finalizadora", payload)
      .then((response) => {
        return response.data;
      });
  }

  DeleteFinalizadora(payload) {
    return api
      .delete("/v1/PdvFinalizadora/Finalizadora/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostPlanoPagamento(payload) {
    return api
      .post("/v1/PdvFinalizadora/PlanoPagamento", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutPlanoPagamento(payload) {
    return api
      .put("/v1/PdvFinalizadora/PlanoPagamento", payload)
      .then((response) => {
        return response.data;
      });
  }

  DeletePlanoPagamento(payload) {
    return api
      .delete("/v1/PdvFinalizadora/PlanoPagamento/" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new PdvFinalizadoraService();
